export default __webpack_public_path__ + "static/media/icon-condicoes-gerais.2e239e1f.svg";